import React from 'react'
import BillingInvoice from '../component/VinmarPools'
import VinmarPoolInvoice from '../component/VinmarPools'

export default function BillingInvoices() {
  return (
    <>
    <VinmarPoolInvoice/>
    </>
  )
}
